import {createModel} from '~~/package/utils/ModelUtil';
import Model from '~~/package/mapper/Model';
import {UserStatusType} from '~~/package/mapper/user/model/UserStatusType';
import {
  ProSkillManagerAssessmentDetailInfoModel
} from '~~/package/mapper/proSkillManager/model/assessment/ProSkillManagerAssessmentDetailInfoModel';

export class ProSkillManagerAssessmentCandidateSummaryModel extends Model {
  constructor(
      public assessmentInfo: ProSkillManagerAssessmentDetailInfoModel = new ProSkillManagerAssessmentDetailInfoModel(),
      public totalCandidates: number = 0,
      public completedCandidates: number = 0,
      public completedRate: number = 0,
      public resultSummary: string = "",
      public top5ByScore: RankItem[] = [],
      public top5ByRate: RankItem[] = [],
      public bottom5ByScore: RankItem[] = [],
      public bottom5ByRate: RankItem[] = [],
      public trackResults: TrackResult[] = []
  ) {
    super();
  }

  public static create(model: Partial<ProSkillManagerAssessmentCandidateSummaryModel>): ProSkillManagerAssessmentCandidateSummaryModel {
    return createModel<ProSkillManagerAssessmentCandidateSummaryModel>(ProSkillManagerAssessmentCandidateSummaryModel, {
      ...model
    });
  }
}

export class Candidate {
  constructor(
      public uuid: string = "",
      public name: string = "",
      public profileImageUrl: string = "",
      public userStatus: UserStatusType = UserStatusType.NORMAL,
      public reportId: number = 0
  ) {}
}

export class RankItem {
  constructor(
      public candidate: Candidate = new Candidate(),
      public reportUrl: string = "",
      public isReportExposure: boolean = false,
      public rank: number = 0,
      public value: number = 0
  ) {}
}

export class TrackResult {
  constructor(
      public trackName: string = "",
      public trackId: number = 0,
      public trackLevelId: number = 0,
      public trackLevelName: string = "",
      public top5ByScore: RankItem[] = [],
      public top5ByRate: RankItem[] = [],
      public bottom5ByScore: RankItem[] = [],
      public bottom5ByRate: RankItem[] = []
  ) {}
}